import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Printer } from "lucide-react";
import { OperatorSheet } from "@/components/OperatorSheet";

export default function OperatorSheetPage() {
  useEffect(() => {
    const st = document.createElement("style");
    st.textContent = "@media print { @page { size: A4 landscape; margin: 0; } }";
    document.head.appendChild(st);
    return () => st.remove();
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0C10]">
      <header className="no-print sticky top-0 z-30 bg-[#12141A]/95 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex flex-wrap items-center gap-2">
          <Button asChild variant="outline" size="sm" className="rounded-full border-white/15 bg-transparent" data-testid="operator-sheet-back-btn">
            <Link to="/admin?tab=bodyshop"><ArrowLeft className="w-4 h-4 mr-1.5" />Indietro</Link>
          </Button>
          <div className="font-display font-bold uppercase text-sm mr-auto">Scheda operatore (vuota)</div>
          <Button size="sm" onClick={() => window.print()} className="rounded-full bg-[#E63946] hover:bg-[#D62828] text-white" data-testid="operator-sheet-print-btn">
            <Printer className="w-4 h-4 mr-1.5" />Stampa
          </Button>
        </div>
      </header>
      <p className="no-print max-w-6xl mx-auto px-4 pt-5 text-xs text-muted-foreground">A4 orizzontale: due schede uguali da dividere a metà, da compilare a penna. Dopo, fotografala e caricala in Carrozzeria → Ore operatori.</p>
      <div className="py-4 px-2 overflow-x-auto">
        <div id="bodyshop-sheet" className="bg-white text-black mx-auto w-[297mm] h-[210mm] flex shadow-2xl" data-testid="operator-sheet">
          <OperatorSheet side="left" />
          <div className="w-0 border-l-2 border-dashed border-neutral-400 relative">
            <span className="absolute top-1/2 -left-[5px] -translate-y-1/2 text-[9px] text-neutral-400 [writing-mode:vertical-rl]">✂ taglia qui</span>
          </div>
          <OperatorSheet side="right" />
        </div>
      </div>
    </div>
  );
}
